import React from "react";
import styles from "./TabNav.module.scss";

export interface TabNavItem {
  id: string | number;
  label: string;
}

interface TabNavProps {
  items: TabNavItem[];
  activeId?: string | number | null;
  onSelect: (item: TabNavItem) => void;
}

const TabNav: React.FC<TabNavProps> = ({ items, activeId, onSelect }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav className={styles.tabNav} aria-label="Section navigation">
      <span className={styles.edgeFadeLeft} />
      <ul className={styles.tabNavScroller}>
        {items.map((item) => (
          <li key={item.id}>
            <button type="button" className={`${styles.tabNavItem} ${activeId === item.id ? styles.active : ""}`} onClick={() => onSelect(item)}>
              {item.label}
            </button>
          </li>
        ))}
      </ul>
      <span className={styles.edgeFadeRight} />
    </nav>
  );
};

export default TabNav;
